import { render, staticRenderFns } from "./ComplaintTakeActionChecklistCard.vue?vue&type=template&id=6fd43ab7&scoped=true"
import script from "./ComplaintTakeActionChecklistCard.vue?vue&type=script&lang=js"
export * from "./ComplaintTakeActionChecklistCard.vue?vue&type=script&lang=js"
import style0 from "./ComplaintTakeActionChecklistCard.vue?vue&type=style&index=0&id=6fd43ab7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd43ab7",
  null
  
)

export default component.exports